import LinkButton from '@root/gatsby-contentful-core/src/components/buttons/link-button';
import LinkButtonModel from '@root/gatsby-contentful-core/src/models/link-button';
import Modal from '@root/gatsby-contentful-core/src/components/modal';
import PartnerPlatformLandingPageForm from '@root/joinroot.com/src/components/forms/partner-platform-landing-page-form/form';
import PropTypes from '@root/vendor/prop-types';
import React, { useState } from '@root/vendor/react';

export default function PartnerPlatformLandingPageButton({
  type = 'primary',
  children,
  onClick: onClickProp = () => {},
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    onClickProp();
    setIsModalOpen(true);
  };

  return (
    <>
      <LinkButton
        onClick={handleButtonClick}
        to={''}
        type={type}
      >
        {children}
      </LinkButton>
      <Modal
        isShowing={isModalOpen}
        name={'partner-platform-landing-page-modal'}
        onClose={() => setIsModalOpen(false)}
      >
        <PartnerPlatformLandingPageForm closeModal={() => setIsModalOpen(false)} />
      </Modal>
    </>
  );
}

PartnerPlatformLandingPageButton.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(Object.values(LinkButtonModel.types)),
};
